var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "admin-detail"
  }, [_c('div', {
    staticClass: "bg-white w-3/4 mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex gap-6 items-center"
  }, [_c('div', {}, [_c('User', {
    attrs: {
      "width": "60",
      "height": "60"
    }
  })], 1), _c('div', {}, [_c('p', {
    staticClass: "text-xl font-medium"
  }, [_vm._v(_vm._s(_vm.userProfile.name))]), _c('p', {
    staticClass: "text-base text-neutral-500 font-medium"
  }, [_vm._v(_vm._s(_vm.userProfile.group))])])]), _c('div', {
    staticClass: "flex mt-4 gap-6"
  }, [_c('p', {
    staticClass: "text-neutral-500 w-36"
  }, [_vm._v("Email")]), _c('p', [_vm._v(":")]), _c('p', [_vm._v(_vm._s(_vm.userProfile.email))])]), _c('div', {
    staticClass: "flex mt-2 gap-6"
  }, [_c('p', {
    staticClass: "text-neutral-500 w-36"
  }, [_vm._v("Username")]), _c('p', [_vm._v(":")]), _c('p', [_vm._v(_vm._s(_vm.userProfile.username))])]), _c('div', {
    staticClass: "flex mt-2 gap-6"
  }, [_c('p', {
    staticClass: "text-neutral-500 w-36"
  }, [_vm._v("Jenis Kelamin")]), _c('p', [_vm._v(":")]), _c('p', [_vm._v(_vm._s(_vm.userProfile.gender === 'M' ? 'Laki-laki' : 'Perempuan'))])]), _c('div', {
    staticClass: "flex mt-2 gap-6"
  }, [_c('p', {
    staticClass: "text-neutral-500 w-36"
  }, [_vm._v("Role")]), _c('p', [_vm._v(":")]), _c('p', [_vm._v(_vm._s(_vm.userProfile.role))])]), _c('div', {
    staticClass: "flex mt-2 gap-6"
  }, [_c('p', {
    staticClass: "text-neutral-500 w-36"
  }, [_vm._v("Activated At")]), _c('p', [_vm._v(":")]), _c('p', [_vm._v(_vm._s(_vm._f("formatDateTime")(_vm.userProfile.verified_at)))])]), _c('div', {
    staticClass: "flex mt-2 gap-6"
  }, [_c('p', {
    staticClass: "text-neutral-500 w-36"
  }, [_vm._v("Login Type")]), _c('p', [_vm._v(":")]), _c('p', [_vm._v(_vm._s(_vm.userProfile.login_type))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }